import { ComponentStyleConfig } from '@chakra-ui/react';

export const editorTextSx = {
  '& p': {
    fontSize: 'md',
    margin: 'unset',
    lineHeight: '25px',
    letterSpacing: 0,
  },
  '& h1, h2, h3, h4, h5, h6': {
    fontWeight: 500,
    fontSize: 'md',
    lineHeight: '19px',
    color: 'M.60',
    letterSpacing: 0,
    marginBottom: '4px',
    marginTop: '4px',
  },
  'ul, ol': {
    paddingX: 4,
    paddingY: 0,
  },
  '& *': {
    wordWrap: 'unset',
    color: 'M.70',
  },
};

export const TextEditor: ComponentStyleConfig = {
  parts: ['root', 'editorContent'],
  baseStyle: {
    root: {
      color: 'textBase',
      wordBreak: 'break-word',
      maxWidth: 640,
      width: '100%',
      minHeight: '100vh',
      margin: 'auto',
      height: '100%',
      borderRadius: 6,
      ' .chakra-fade': {
        height: '100%',
      },
      '& [data-tippy-root], .tippy-box, .tippy-content': {
        outline: 'none',
        '&:focus-visible': {
          outline: 'none',
        },
      },
    },
    text: editorTextSx,
    editorContent: {
      height: '100%',
      '.ProseMirror': {
        outline: 'none',
        height: '100%',
        py: 6,
        '&:focus-visible': {
          outline: 'none',
        },
        'p.is-editor-empty:first-of-type::before': {
          color: 'textPlaceholder',
          content: 'attr(data-placeholder)',
          float: 'left',
          height: 0,
          pointerEvents: 'none',
        },
        '.ProseMirror-yjs-selection + .caret-root': {
          padding: 'unset',
          margin: 'unset',
        },
        '.caret-root': {
          position: 'relative',
          padding: '0 10px !important',
          margin: '0 -10px !important',
          '&:hover .caret-label': {
            opacity: '1 !important',
          },
        },
        '.caret': {
          position: 'absolute',
          bottom: '0px',
          height: '23px',
          width: '2px',
          background: 'var(--user-color)',
          pointerEvents: 'none',
          wordBreak: 'normal',
          '::before': {
            content: '""',
            position: 'absolute',
            top: '0px',
            left: '-1px',
            width: '4px',
            height: '4px',
            background: `var(--user-color)`,
            borderRadius: '100%',
          },
        },
        '.caret-label': {
          lineHeight: 1,
          opacity: 0,
          transition: 'opacity 0.2s',
          position: 'absolute',
          userSelect: 'none',
          whiteSpace: 'nowrap',
          backgroundColor: `var(--user-color)`,
          borderRadius: '2px',
          color: 'white',
          fontSize: '10px',
          fontWeight: 500,
          fontStyle: 'normal',
          left: '-1px',
          padding: '2px',
          top: '-8px',
        },
      },
    },
  },
  variants: {},
  sizes: {},
  defaultProps: {},
};
